import TeamMembersTable from './TeamMembersTable'

export default TeamMembersTable



// WEBPACK FOOTER //
// ./src/legacy/containers/Tables/TeamMembersTable/index.js